export const slugify = (value: string): string =>
  value.trim().toLowerCase().replace(/\s+/g, '_')
